import { z } from 'zod'

export const VServerTemplate = z.object({
  id: z.number(),
  slug: z.string(),
  name: z.string(),
  os_family: z.string(),
  os_name: z.string(),
  os_version: z.string(),
  icon: z.string().nullable().optional(),
  min_disk_gb: z.number().default(10),
  active: z.boolean().default(true),
  sort_order: z.number().default(0)
})
export type VServerTemplate = z.infer<typeof VServerTemplate>
